import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import {apiUrl} from'../Config/Config';
import axios from 'axios';
import Pagination from "react-js-pagination";
import QueryContext from '../QueryContext';
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";
import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { GET_DASHBOARDLIST  } from '../../actions';

class List extends Component {

static contextType = QueryContext;
  constructor(props)
  {
    super(props);
    this.state = {
      dashboardlist:'',
      totalRecord :'', 
      totalRecordUsers : '',
      totalRecordTechnician : '',
      totalRecordClinic: '',
      totalRecordCompanies : '',
      totalRecordcategory :'',
      totalRecordpayment :'',
      totalRecordDoctor :'',
      totalRecordCategories : '',
      totalRecordProductCateogory : '',
   
      totalRecordabusivewords :'',
      totalRecordadvertisement : '',
      totalRecordbookinghistory :'',
      totalRecordlocation :'',
      totalRecordfonts: '',
      totalRecordguide : '',
      totalRecordoffers : '',
      totalRecordchaticons :"",
      totalRecordproductbooking:'',
      totalRecordmembership:'',
    };
    
    
    }

   
    componentDidMount() {
      var qs = require('qs');
      var admin_id = localStorage.getItem("admin_id");
      var loggedas = localStorage.getItem("loggedas");
      var postobject = {
      activePage: 1,
      search_all: '',
      admin_id: admin_id,
      loggedas: loggedas
      };
      // this.props.getDashboardList(qs.stringify(postobject));

      axios.post(apiUrl+"dashboard/list",qs.stringify(postobject)).then(res => {
        if(res.data.status === 'success'){         
          this.setState({ 
            totalRecord : res.data.records_count_product, 
            totalRecordUsers : res.data.records_count_users,
            totalRecordTechnician : res.data.records_count_technician,
            totalRecordClinic : res.data.records_count_clinic,
            totalRecordCompanies : res.data.records_count_companies,
            totalRecordcategory : res.data.records_count_category,
            totalRecordpayment : res.data.records_count_payment,
            totalRecordDoctor : res.data.records_count_doctor,
            totalRecordCategories : res.data.records_count_categories,
            totalRecordProductCateogory : res.data.records_count_product_category,
         
            totalRecordabusivewords : res.data.records_count_abusivewords,
            totalRecordadvertisement : res.data.records_count_advertisement,
            totalRecordbookinghistory : res.data.records_count_bookinghistory,
            totalRecordlocation : res.data.records_count_location,
            totalRecordfonts: res.data.records_count_fonts,
            totalRecordguide : res.data.records_count_guide,
            totalRecordoffers : res.data.records_count_offers,
            totalRecordchaticons : res.data.records_count_chat_icons,
            totalRecordproductbooking:res.data.records_count_productbooking,
            totalRecordmembership:res.data.records_count_membership,
          });
        }else{         
          this.setState({
            dashboardlist:'',
            totalRecord :'', 
            totalRecordUsers : '',
            totalRecordTechnician : '',
            totalRecordClinic : '',
            totalRecordCompanies : '',
            totalRecordcategory :'',
            totalRecordpayment :'',
            totalRecordDoctor :'',
            totalRecordCategories : '',
            totalRecordProductCateogory : '',
         
            totalRecordabusivewords :'',
            totalRecordadvertisement : '',
            totalRecordbookinghistory :'',
            totalRecordlocation :'',
            totalRecordfonts: '',
            totalRecordguide : '',
            totalRecordoffers : '',
            totalRecordchaticons:"",
            totalRecordproductbooking:'',
            totalRecordmembership:'',
          });
        }
      }); 

   }




  render() {
        const { ehrpanel } = this.context;

    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="dashboard" />
      
      <div className="content"> 
        <div className="content-wrapper">
              <div class="content-wrapper-before"></div>
              <div className="car-listing-wrap dashboard-wrap leaa-admin-head card">

                  <div className="title">
                    <h3>Dashboard</h3>
                  </div>

                  <div className="form-row first">

                        {localStorage.getItem('admin_id') === '1' ?  
                        <div className="form-left">
                        <div className="card pull-up border-top-info border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge">{this.state.totalRecordUsers}</h4>
                            </div>
                              <a href="user" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="font-large-1 text-bold-400">Users <i className="ft-users float-right"></i></h4>
                                </div>
                                <div className="card-footer p-1">
                                </div>
                            </div>
                       </a>
                    </div>
                          </div> : ''}
                    <div className="form-right">
                    <div className="card pull-up border-top-info-yellow border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge-yellow card-title-yellow">{this.state.totalRecordbookinghistory}{/* <span className="badge badge-pill badge-info float-right m-0">5+</span>*/}</h4>
                            </div>
                              <a href="appointment-history" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="font-large-1 text-bold-400">Appointment History<i className="ft-server float-right"></i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                          </a>
                        </div>   
                          </div>
                    </div> 

                    <div className="form-row ">
            					<div className="form-left">
            					
                        <div className="card pull-up border-top-info-yellow border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge-yellow card-title-yellow">{this.state.totalRecordTechnician}{/* <span className="badge badge-pill badge-info float-right m-0">5+</span>*/}</h4>
                            </div>
                              <a href="technicians" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="font-large-1 text-bold-400">Technicain<i className="ft-server float-right"></i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                          </a>
                        </div>   
            					</div>
                     
            					 <div className="form-right">
                         <div className="card pull-up border-top-info-purple border-top-3 rounded-0">
                            <div className="card-header">
                            <h4 className="card-title card-badge-purple card-title-purple">{this.state.totalRecordDoctor}{/* <span className="badge badge-pill badge-info float-right m-0">5+</span>*/}</h4>
                             </div>
                              <a href="doctors" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="font-large-1 text-bold-400">Vets <i className="ft-users float-right"></i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                            </a>
                          </div>
            					  </div> 
                      


            				</div>
                    {/* --------------------- */}
                    {(!ehrpanel)?<> 
                    <div className="form-row ">                      
                        <div className="form-left">
                        <div className="card pull-up border-top-info border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge">{this.state.totalRecordmembership}</h4>
                            </div>
                            <a href="Membership" className="">
                              <div className="card-content collapse show">
                                  <div className="card-body p-1">
                                      <h4 className="font-large-1 text-bold-400">Membership <i className="ft-users float-right"></i></h4>
                                  </div>
                                  <div className="card-footer p-1">
                                  </div>
                              </div>
                            </a>
                        </div>
                          </div> 
                        <div className="form-right">
                        <div className="card pull-up border-top-info-blue border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge card-title-blue">{this.state.totalRecordproductbooking}{/* <span className="badge badge-pill badge-info float-right m-0">5+</span>*/}</h4>
                            </div>
                              <a href="product-booking-history" className="">
                              <div className="card-content collapse show">
                                  <div className="card-body p-1">
                                      <h4 className="font-large-1 text-bold-400">Product Order History<i className="ft-server float-right"></i></h4>
                                  </div>
                                  <div className="card-footer p-1">
                                  </div>
                              </div>
                          </a>
                        </div> 
                          </div>
                        </div> 

                        <div className="form-row ">                      
                        <div className="form-left">
                        <div className="card pull-up border-top-info border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge">{this.state.totalRecordabusivewords}</h4>
                            </div>
                            <a href="abusivewords" className="">
                              <div className="card-content collapse show">
                                  <div className="card-body p-1">
                                      <h4 className="font-large-1 text-bold-400">Abusive Words <i className="ft-users float-right"></i></h4>
                                  </div>
                                  <div className="card-footer p-1">
                                  </div>
                              </div>
                            </a>
                        </div>
                          </div> 
                        <div className="form-right">
                        <div className="card pull-up border-top-info-blue border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge card-title-blue">{this.state.totalRecordadvertisement}{/* <span className="badge badge-pill badge-info float-right m-0">5+</span>*/}</h4>
                            </div>
                              <a href="Advertisement" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="font-large-1 text-bold-400">Advertisement<i className="ft-server float-right"></i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                          </a>
                        </div> 
                          </div>
                        </div> 

                        <div className="form-row ">
                        <div className="form-left">

                        


                        <div className="card pull-up border-top-info-blue border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge card-title-blue">{this.state.totalRecord}{/* <span className="badge badge-pill badge-info float-right m-0">5+</span>*/}</h4>
                            </div>
                              <a href="product" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="font-large-1 text-bold-400">Products<i className="ft-server float-right"></i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                          </a>
                        </div> 
                        </div>

                        <div className="form-right">
                        <div className="card pull-up border-top-info-purple border-top-3 rounded-0">
                            <div className="card-header">
                            <h4 className="card-title card-badge-purple card-title-purple">{this.state.totalRecordlocation}{/* <span className="badge badge-pill badge-info float-right m-0">5+</span>*/}</h4>
                            </div>
                              <a href="Location" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="font-large-1 text-bold-400">Location <i className="ft-users float-right"></i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                            </a>
                          </div>
                        </div> 
                        </div>
                    {/* -------------- */}

                    <div className="form-row ">
                       
                        <div className="form-left">
                        <div className="card pull-up border-top-info border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge">{this.state.totalRecordfonts}</h4>
                            </div>
                              <a href="fonts" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="font-large-1 text-bold-400">Fonts <i className="ft-users float-right"></i></h4>
                                </div>
                                <div className="card-footer p-1">
                                </div>
                            </div>
                        </a>
                        </div>
                          </div> 
                        <div className="form-right">
                        <div className="card pull-up border-top-info-blue border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge card-title-blue">{this.state.totalRecordguide}{/* <span className="badge badge-pill badge-info float-right m-0">5+</span>*/}</h4>
                            </div>
                              <a href="Guide" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="font-large-1 text-bold-400">Guide<i className="ft-server float-right"></i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                          </a>
                        </div> 
                          </div>
                        </div> 

                        <div className="form-row ">
                        <div className="form-left">

                        <div className="card pull-up border-top-info-yellow border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge-yellow card-title-yellow">{this.state.totalRecordoffers}{/* <span className="badge badge-pill badge-info float-right m-0">5+</span>*/}</h4>
                            </div>
                              <a href="offers" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="font-large-1 text-bold-400">Offers<i className="ft-server float-right"></i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                          </a>
                        </div>   
                        </div>

                        <div className="form-right">
                        <div className="card pull-up border-top-info-purple border-top-3 rounded-0">
                            <div className="card-header">
                            <h4 className="card-title card-badge-purple card-title-purple">{this.state.totalRecordchaticons}{/* <span className="badge badge-pill badge-info float-right m-0">5+</span>*/}</h4>
                            </div>
                              <a href="chat" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="font-large-1 text-bold-400">Emoji Managements <i className="ft-users float-right"></i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                            </a>
                          </div>
                        </div> 
                        </div>
                      </>:''}
                    {/* -------------- */}
                    <div className="form-row ">
            					<div className="form-left">            					
                      <div className="card pull-up border-top-info border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge">{this.state.totalRecordClinic}</h4>
                            </div>
                              <a href={ehrpanel?'clinic?ehrpanel=true':"clinic"} className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="font-large-1 text-bold-400">Clinic <i className="ft-users float-right"></i></h4>
                                </div>
                                <div className="card-footer p-1">
                                </div>
                            </div>
                       </a>
                    </div> 
            					</div>
                     
            					 {/* <div className="form-right">
                         <div className="card pull-up border-top-info-purple border-top-3 rounded-0">
                            <div className="card-header">
                            <h4 className="card-title card-badge-purple card-title-purple">{this.state.totalRecordDoctor}</h4>
                             </div>
                              <a href="doctors" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="font-large-1 text-bold-400">Vets <i className="ft-users float-right"></i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                            </a>
                          </div>
            					  </div>  */}
                      
                      

            				</div>
                    
                    <div className="form-row ">
            					<div className="form-right">
            					
                     
            					</div>
                     
            					 {/* <div className="form-right">
                         <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                            <div className="card-header">
                            <h4 className="card-title card-badge card-title-black">{this.state.totalRecordCategories}</h4>
                             </div>
                              <a href="product" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="font-large-1 text-bold-400">Category <i className="ft-users float-right"></i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                            </a>
                          </div>
            					  </div>  */}
            				</div>
                     <div className="form-row ">
            					<div className="form-left">
                       
            					</div>
                    </div>

                    {/* -------------------- */}
                      
                </div>
          </div>  
      </div>
      
    </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    dashboardlist: state.dashboardlist,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getDashboardList: (formVal) =>{
      dispatch({ type: GET_DASHBOARDLIST, formVal});
   },
   
  }
}
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(List));